// extracted by mini-css-extract-plugin
export var attribution = "_al-4";
export var authorName = "_al-5";
export var quote = "_al-3";
export var testimonial = "_al-2";
export var trustedBy = "_al-0";
export var trustedByLabel = "_al-1";